import { z } from 'zod';

export const phoneNumberRegex = /^\d(\s?\d){5,15}$/;

export const phoneNumberValidation = z
  .string()
  .regex(phoneNumberRegex, 'Invalid phone number format');

export const optionalTextValidation = z.string().trim().optional().nullable();
